// import React from 'react';
import React, { useState, useEffect, useContext } from 'react';
import $ from 'jquery';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
// import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
// import Tooltip from '@mui/material/Tooltip';
// import MenuItem from '@mui/material/MenuItem';
// import AdbIcon from '@mui/icons-material/Adb';

// Wallet connection check & blockchain button control
    import { setupBlockchain } from './App';
// Web3-Onboard
  import Onboard from '@web3-onboard/core';
  import injectedModule from '@web3-onboard/injected-wallets';

import { ThemeProvider, createTheme, rgbToHex } from '@mui/material/styles';
import './index.css';

// Set base URLs & IDs
    let WEB3_ONBOARD_ID, PSISCOPE_ICON, NETWORK_CHAIN_ID, FAQ_URL;

    if (process.env.NODE_ENV === "development") {
        console.log("local environment");
        WEB3_ONBOARD_ID = process.env.REACT_APP_WEB3_ONBOARD_ID_LOCAL;
        PSISCOPE_ICON = process.env.REACT_APP_PSISCOPE_ICON_LOCAL;
        NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_LOCAL;
        FAQ_URL = process.env.REACT_APP_PSISCOPE_FAQ;
    } else {
        console.log("production environment");
        WEB3_ONBOARD_ID = process.env.REACT_APP_WEB3_ONBOARD_ID_PRODUCTION;
        PSISCOPE_ICON = process.env.REACT_APP_PSISCOPE_ICON_PRODUCTION;
        NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_PRODUCTION;
        FAQ_URL = process.env.REACT_APP_PSISCOPE_FAQ;  
    }

// const pages = ['App', 'Browse'];
// const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

export function switchNavConnectButtonText(account) {
    if (account != "CONNECT WALLET") {
      const accountTruncated = account.slice(0, 6) + '...' + account.slice(-4);
      $('#connect-btn-big').html(accountTruncated);
      const accountTruncated2 = account.slice(0, 5) + '...' + account.slice(-4);
      $('#connect-btn-small').html(accountTruncated2);
    } else {
      $('#connect-btn-big').html("CONNECT WALLET");
      $('#connect-btn-small').html("CONNECT");
    }
}

function getPageName() {
  const currentURL = window.location.href;
  const last3Chars = currentURL.slice(-3);
  console.log("Page id: " + last3Chars);
  return last3Chars.toLowerCase();
}

function checkPageNameAndCheckWallet(pageName, previous = null) {
  console.log("checkPageNameAndCheckWallet");
    // if (pageName == "ger" || pageName == "er/" || pageName == "000" || pageName == "00/" || pageName == "001" || pageName == "01/" || pageName == "002" || pageName == "02/") {
        if (previous == 'no-previous') {
          setupBlockchain('no-previous');
        } else {
          setupBlockchain();
        }
    // }
}

// Web3 Onboard 
    const injected = injectedModule()

    export const onboard = Onboard({
      wallets: [injected],
      chains: [
        {
          id: '0x1',
          token: 'ETH',
          label: 'Ethereum',
          // rpcUrl: 'https://mainnet.infura.io/v3/${INFURA_ID}'
          rpcUrl: 'https://mainnet.infura.io/v3/'
        },
        {
          id: '0x89',
          token: 'POL',
          label: 'Polygon Mainnet',
          // rpcUrl:'https://rpc.ankr.com/polygon',
          rpcUrl:'https://polygon-rpc.com',
          // rpcUrl: 'https://rpc-mainnet.maticvigil.com',
          blockExplorerUrl: 'https://polygonscan.com'
        },
        {
          id: '0x2105', // '8453'
          token: 'ETH',
          label: 'Base Mainnet',
          rpcUrl:'https://base-rpc.publicnode.com',
          // rpcUrl:'https://mainnet.base.org',
          // rpcUrl: 'https://base-mainnet.infura.io',
          blockExplorerUrl: 'https://basescan.org/'
        },
        {
          id: '0x14a34', // Base Sepolia Test Netwok ID in hex
          token: 'ETH',
          label: 'Base Sepolia Testnet',
          rpcUrl: 'https://base-sepolia-rpc.publicnode.com',
          blockExplorerUrl: 'https://sepolia.basescan.org'
        },
        {
          id: '0x7a69',
          token: 'LOCAL',
          label: 'Hardhat'
        }
      ],
      accountCenter: {
        desktop: {
          position: 'topRight',
          enabled: true,
          minimal: false
        },
        mobile: {
          position: 'bottomRight',
          enabled: true,
          minimal: true
        }
      },
      appMetadata: {
        name: 'Psiscope',
        icon: PSISCOPE_ICON,
        // logo: myLogo, // svg string logo
        description: 'Psi + blockchain = reality revolution',
        recommendedInjectedWallets: [
          { name: 'MetaMask', url: 'https://metamask.io' },
          { name: 'Coinbase', url: 'https://wallet.coinbase.com/' }
        ]
      },
    //   apiKey: WEB3_ONBOARD_ID, // added
      notify: { // added
        desktop: {
          enabled: true,
          transactionHandler: transaction => {
            console.log({ transaction })
            if (transaction.eventCode === 'txPool') {
              return {
                type: 'success',
                message: 'Your transaction is in progress',
              }
            }
          },
          position: 'topRight'
        },
        mobile: {
          enabled: true,
          transactionHandler: transaction => {
            console.log({ transaction })
            if (transaction.eventCode === 'txPool') {
              return {
                type: 'success',
                message: 'Your transaction is in progress',
              }
            }
          },
          position: 'topRight'
        }
      }

    })


export const resetWeb3Onboard = async () => {

	console.log('resetWeb3Onboard called');
	const wallets_ = onboard.state.get().wallets;

	for (const wallet_ of wallets_) {
		await onboard.disconnectWallet({ label: wallet_.label });
	}
	console.log('All wallets disconnected. Web3-Onboard state reset.');
};

export async function connectWallet() {

	console.log('connectWallet called');
	await resetWeb3Onboard(); 

	const wallets = await onboard.connectWallet();
	console.log("wallets check: " + wallets);
	if (wallets != "") { // If wallet is connected, check chain
		switchNetwork();
	}
}

export async function switchNetwork() {

	console.log("Check network/chain");
	// Check chain ID
		let chainID = await window.ethereum.request({ method: 'eth_chainId' });
		console.log('Chain ID: ' + chainID);
	if (chainID != NETWORK_CHAIN_ID) { // if wrong chain...
		const networkSwitch = await onboard.setChain({ chainId: NETWORK_CHAIN_ID });
		console.log("New network: " + networkSwitch);
	}

  const pageName = getPageName(); // Function triggered * * *
  checkPageNameAndCheckWallet(pageName); // Function * * *
}

async function handleNavbarConnectClick() {
	console.log("Call connectWallet")
	connectWallet();
}

export async function refreshAccountCenterWithoutPrompt(onboard) { // new 7/4/25
	const [wallet] = onboard.state.get().wallets
	if (!wallet) return

	// Disconnect the wallet without triggering UI
	await onboard.disconnectWallet({ label: wallet.label })

	// Reconnect silently without showing modal
	await onboard.connectWallet({
		autoSelect: {
			label: wallet.label,
			disableModals: true
		}
	})
}

// Auto-selsect wallet

  // Subscsribe for auto-selecting wallet when user returns
    const walletsSub = onboard.state.select('wallets')
    const { unsubscribe } = walletsSub.subscribe((wallets) => {
      const connectedWallets = wallets.map(({ label }) => label)
      window.localStorage.setItem('connectedWallets', JSON.stringify(connectedWallets));
    })

	// Get 'connectedWallets' from local storage
		export async function getPreviousWallets() {
			const previousWallets = JSON.parse(window.localStorage.getItem('connectedWallets'));
			return previousWallets;
		}

  // Auto-select previously used wallet
    async function autoSelectWallet() {
        console.log("wallet auto select")

		const previouslyConnectedWallets = await getPreviousWallets();
		console.log("Previously connected wallets: " + previouslyConnectedWallets);

        if (previouslyConnectedWallets !== null) {
            if (previouslyConnectedWallets[0]) {
				// Connect the most recently connected wallet (first in the array)
				console.log("Previous wallet detected");
				await onboard.connectWallet({ autoSelect: previouslyConnectedWallets[0] });
				const pageName = getPageName(); // Function triggered * * *
				checkPageNameAndCheckWallet(pageName); // Function * * *
            } else {
				console.log("No previous wallet detected at index 0");
				const pageName = getPageName(); // Function triggered * * *
				checkPageNameAndCheckWallet(pageName, 'no-previous'); // Function * * *
            }
        } else {
            console.log("No previous wallet detected");
            const pageName = getPageName(); // Function triggered * * *
            checkPageNameAndCheckWallet(pageName, 'no-previous'); // Function * * *
        }
    }
    
  // -------------------
  // Check if wallet is installed [ # # # SEQUENCE STARTS HERE on page load # # # ]
  // ---------------------
	// if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 
	// 	autoSelectWallet(); // Function triggered * * *
	// } else {
	// 	console.log("No wallet detected - 0");
	// 	const pageName = getPageName(); // Function triggered * * *
	// 	checkPageNameAndCheckWallet(pageName, 'no-previous'); // Function * * *
	// }
	setupBlockchain('no-previous'); // Added 7/4/25 ['no previous' not being used]


function NavBar({onMainClick}) {

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  function handleNavbarResetClick() {
    console.log("Call resetWallet");
    window.location.reload();
  }
  
  // Set dark theme
    const darkTheme = createTheme({
      palette: {
        mode: 'dark',
        // primary: deepOrange,
        // divider: deepOrange[700],
        background: {
          // default: deepOrange[900],
          // paper: grey[900],
          paper: '#1f242e',
        },
        text: {
          // primary: '#fff',
          // secondary: grey[500],
        },
      },
    });
  

  return (

    <ThemeProvider theme={darkTheme}>

    <AppBar position="static">
      <Container maxWidth="xl" style={{border:'0px solid green'}}>
        <Toolbar disableGutters>

          {/* Desktop */}
            <img id="psiscope-logo-nav-left" src={PSISCOPE_ICON} />
            {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              PSISCOPE
            </Typography>

          {/* Mobile */}

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>

              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                  <Button sx={{ my: 2, color: 'white', display: 'block' }} onClick={handleNavbarResetClick} >
                      Reset
                  </Button>
                  <Button sx={{ my: 2, color: 'white', marginTop: '-12px', marginLeft: '0px', marginRight: '5px', display: 'block' }} href={FAQ_URL} target="_blank" rel="noopener noreferrer">
                    FAQ
                  </Button>

                  <Button sx={{ my: 2, color: 'white', marginTop: '-12px', marginLeft: '0px', marginRight: '5px', display: 'block' }} onClick={handleNavbarConnectClick} >
                      Connnect
                  </Button>

              </Menu>
            </Box>

            <img id="psiscope-logo-nav-center" src={PSISCOPE_ICON} style={{display: 'none'}} />
            {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              PSISCOPE
            </Typography>

          {/* Desktop */}

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex', alignItems:'center' }, justifyContent:'center' }}>

				<Typography variant="body1" display={{border: '0px solid red'}} style={{ margin: '0px 13px 0px -7px', fontSize:'15px', color: 'rgb(173, 173, 173)' }}>
					THIS APP:
				</Typography>

                <Button sx={{ my: 2, color: 'lightgray', display: 'block' }} style={{ fontSize:'15px', color:'rgb(232, 232, 232)' }} onClick={handleNavbarResetClick} >
                    Reset
                </Button>
                <Button sx={{ my: 2, color: 'lightgray', display: 'block' }} style={{ fontSize:'15px', color:'rgb(232, 232, 232)' }} onClick={() => window.open(FAQ_URL, '_blank')}>
                    FAQ
                </Button>

            </Box>


          {/* Connect Wallet */}

          <Box sx={{ flexGrow: 0, marginLeft:'auto' }}>

              <Button id="connect-btn-big" variant="outlined" style={{ minWidth:'165px', fontWeight: "bold"}} onClick={handleNavbarConnectClick} >
                  Connect Wallet
              </Button>
              <Button id="connect-btn-small" variant="outlined" style={{ display: "none"}} onClick={handleNavbarConnectClick} >
                  Connect
              </Button>

          </Box>

        </Toolbar>
      </Container>
    </AppBar>

    </ThemeProvider>

  );
}

export default NavBar;